import React, { createContext, MutableRefObject, useEffect, useRef } from 'react';
import { CalendarStore, createCalendarStore } from './calendarStore';
import { StoreApi, UseBoundStore } from 'zustand';
import { IResource } from './types';
import { memoize } from 'lodash';

export const CalendarStoreContext = createContext<UseBoundStore<StoreApi<CalendarStore>> | null>(null);

type CalendarStoreProviderProps = Pick<CalendarStore, 'slots' | 'resources'>;

const memoizedResources: (resources: IResource[]) => IResource[] = memoize((resources: IResource[]) =>
	resources.map(resource => ({ ...resource, slots: [] }))
);

export const CalendarStoreProvider: React.FC<CalendarStoreProviderProps> = ({ slots, resources, children }) => {
	const storeRef: MutableRefObject<UseBoundStore<StoreApi<CalendarStore>>> = useRef(
		createCalendarStore({ slots, resources })
	);

	useEffect(() => {
		// updating the store when the resources or slots change
		storeRef.current.setState(state => ({ ...state, slots, resources: memoizedResources(resources) }), false);
	}, [slots, resources, storeRef.current]);

	useEffect(() => {
		// clean up the store when the component unmounts
		return () => storeRef.current.destroy();
	}, []);

	return <CalendarStoreContext.Provider value={storeRef.current}>{children}</CalendarStoreContext.Provider>;
};

CalendarStoreProvider.displayName = 'CalendarStoreProvider';
